import { render, staticRenderFns } from "./icon-svg.vue?vue&type=template&id=08225c98"
import script from "./icon-svg.vue?vue&type=script&lang=js"
export * from "./icon-svg.vue?vue&type=script&lang=js"
import style0 from "./icon-svg.vue?vue&type=style&index=0&id=08225c98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports